import { Component, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { MemoryMonitorService } from './core/services/other/memory.monitor.service';
import { AuthService } from './core/services/auth/auth.service';

@Component({
  standalone: true,
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('platinum_nexus_2');

  private isCheckingUser = signal(false);
  private authService = inject(AuthService);
// private router = inject(Router);

  constructor(private router: Router,private memoryMonitor: MemoryMonitorService) {
      //¿Cómo probar qué entorno está activo? jajei
      //console.log('PROYECTO EN PRODUCCIOM? = ', environment.production);

         // Verificación del usuario al inicializar la app
      this.verifyUserOnAppStart();
  }

    private verifyUserOnAppStart() {
    // Solo verificar si hay token guardado
    if (this.authService.isAuthenticated()) {
      this.isCheckingUser.set(true);
      
      this.authService.verifyUserSimple("app.ts").subscribe({
        next: (isValid) => {
          this.isCheckingUser.set(false);
          if (!isValid) {
            // Usuario fue eliminado, redirigir al login
            this.router.navigate(['/login']);
          }
          // Si es válido, no hacer nada (la app carga normal)
        },
        error: () => {
          this.isCheckingUser.set(false);
          this.router.navigate(['/login']);
        }
      });
    }
  }

  //  ngOnInit() {
  //   // loguea memoria solo una vez
  //   this.memoryMonitor.logMemoryUsage();

  //   // o iniciar monitoreo en vivo cada 3 segundos
  //   this.memoryMonitor.startLiveMonitoring(3000);
  // }

  // ngOnDestroy() {
  //   // importante detener el monitoreo para no generar memory leaks
  //   this.memoryMonitor.stopLiveMonitoring();
  // }

   goToLogin() {
    this.router.navigate(['/login']);
  }

  goToDasboard() {
    this.router.navigate(['/dashboard']); 
  }

 
}
